import React from "react";
import PolygonBox from "../../../components/questionBoxs/PolygonBox";
import RoundedBox from "../../../components/questionBoxs/RoundedBox";
import RoundBox from "../../../components/questionBoxs/RoundBox";
import PolygonBoxBottom from "../../../components/questionBoxs/PolygonBoxBottom";
import PolygonBoxTop from "../../../components/questionBoxs/PolygonBoxTop";

function QuestionButton({ type, number,height=30,width=30 }) {
  const componentMap = {
    notVisited: <RoundedBox number={number} height={height} width={width} />,
    active: <RoundedBox color="#3498db" textColor="white" number={number} height={height} width={width} />,
    notAnswered: <PolygonBoxBottom number={number} width={width} height={height} />,
    attempted: <PolygonBoxTop number={number} color="green" width={width} height={height} />,
    marked: <RoundBox number={number} width={width} height={height} />,
    markedWithAnswered: <RoundBox number={number} showIcon={true} isChecked={true} width={width} height={height} />,
  };

  return componentMap[type] || <RoundedBox number={number} />;
}

export default QuestionButton;
